import {
    ADD_TO_CART,
    REMOVE_FROM_CART,
    INCREMENT_QTY,
    DECREMENT_QTY } from "../constants/ActionTypes";



export default function cartReducer(state = {
    cart: []
}, action) {
    switch (action.type) {
        case ADD_TO_CART:
            const productId = action.product.product_id
            if (state.cart.findIndex(product => product.product_id === productId) !== -1) {
                const cart = state.cart.reduce((cartAcc, product) => {
                    if (product.product_id === productId) {
                        // not getting price in products so temp set order param
                        cartAcc.push({ ...product, qty: product.qty+1, sum: (product.colors[0].price.price)*(product.qty+1) }) // Increment qty
                    } else {
                        cartAcc.push(product)
                    } 
                    return cartAcc
                }, []) 
                return { ...state, cart }
            }

            return { ...state, cart: [...state.cart, { ...action.product, qty: action.qty, sum: (action.product.colors[0].price.price)*action.qty }] }

        case DECREMENT_QTY:
            
            if (state.cart.findIndex(product => product.product_id === action.productId) !== -1) {
                const cart = state.cart.reduce((cartAcc, product) => {
                    if (product.product_id === action.productId && product.qty > 1) {
                        cartAcc.push({ ...product, qty: product.qty-1, sum: (action.product.colors[0].price.price)*(product.qty-1) }) // Decrement qty
                    } else {
                        cartAcc.push(product)
                    }

                    return cartAcc
                }, [])

                return { ...state, cart }
            }

            return { ...state, cart: [...state.cart, { ...action.product, qty: action.qty, sum: action.product.colors[0].price.price*action.qty }] }

        case REMOVE_FROM_CART:
            return {
                cart: state.cart.filter(item => item.product_id !== action.product.product_id)
            }

        default:
    }
    return state;
}
